module.exports = __webpack_public_path__ + "653e4d141e1ae41fffdcfc154e859848.ttf";